import React, { useState } from "react";
import { useBilling } from "../../../../context/BillingContext";

export const CancelDowngradeModal = ({ onClose, refetchBilling }) => {
  const { cancelDowngrade } = useBilling();
  const [loading, setLoading] = useState(false);

  const handleCancelDowngrade = async () => {
    try {
      setLoading(true);

      const res = await cancelDowngrade();

      if (res?.success) {
        refetchBilling && refetchBilling();
        onClose();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div
        className="confirmation-modal-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirmation-modal-content">
          <div className="confirmation-modal-body">
            <div className="modal-icon-container">
              <i className="bi bi-exclamation-triangle-fill"></i>
            </div>

            <h5 className="confirmation-modal-title">
              Cancel Downgrade
            </h5>

            <p className="confirmation-modal-text">
              Are you sure you want to cancel your scheduled plan downgrade?
              Your current plan will remain active.
            </p>

            <div className="confirmation-modal-actions">
              <button
                className="btn-premium btn-premium-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Go Back
              </button>

              <button
                className="btn-premium btn-premium-danger"
                onClick={handleCancelDowngrade}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Processing...
                  </>
                ) : (
                  "Yes, Cancel"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};